import { wordTrack, reasonTrack } from '@/constants/marquee'

export const Marquee = () => {
  // Duplicate each list so the loop is seamless.

  return (
    <section className="relative overflow-hidden bg-white py-16 lg:py-24">
      <div className="rotate-3 scale-110 space-y-5">
        {/* Diagonal dark band, like the guide's "WHY US?" strip */}
        <div className="overflow-hidden border-y border-white/10 bg-ibon-dark py-6">
          <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
            {wordTrack.map((label, index) => (
              <div key={`${label}-${index}`} className="flex items-center gap-10">
                <span className="text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl lg:text-5xl">
                  {label}
                </span>
                <span className="text-2xl font-bold text-ibon-sky lg:text-3xl">/</span>
              </div>
            ))}
          </div>
        </div>

        {/* Outlined pill row scrolling the opposite direction */}
        <div className="overflow-hidden py-2">
          <div className="flex w-max animate-marquee-reverse items-center gap-5 whitespace-nowrap">
            {reasonTrack.map((label, index) => (
              <span
                key={`${label}-${index}`}
                className="inline-flex items-center rounded-full border border-ibon-dark/20 px-8 py-3 text-2xl font-bold uppercase tracking-tight text-ibon-dark sm:text-3xl lg:text-4xl"
              >
                {label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
